import React, { useState, useEffect } from 'react'
import './GameSummary.css'
import { useParams, Link } from 'react-router-dom'
import Footer from '../UIElements/Footer'

const GameSummary = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [loadedGame, setLoadedGame] = useState()
	const [loadedGameStats, setLoadedGameStats] = useState()
	const [winner, setWinner] = useState()
	const [loser, setLoser] = useState()
	const gameId = useParams().gameId
	const [homeRoster, setHomeRoster] = useState()
	const [homeTeamName, setHomeTeamName] = useState()
	const [visitorRoster, setVisitorRoster] = useState()
	const [visitorTeamName, setVisitorTeamName] = useState()
	const [rosterPlayerGameStats, setRosterPlayerGameStats] = useState()
	const [gameStats, setGameStats] = useState()
	const [venue, setVenue] = useState()
	const [leagueName, setLeagueName] = useState()
	const [allGoalsFromThisGame, setAllGoalsFromThisGame] = useState()
	const [allPenaltiesFromThisGame, setAllPenaltiesFromThisGame] = useState()
	const [homeGoalsTotal, setHomeGoalsTotal] = useState()
	const [visitorGoalsTotal, setVisitorGoalsTotal] = useState()

	// goes to backend, admin-controller, getGameData
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + `/admin/game/${gameId}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLoadedGame(responseData.game)
				setLoadedGameStats(responseData.gameStats)
				setAllGoalsFromThisGame(responseData.allGoalsFromThisGame)
				setAllPenaltiesFromThisGame(responseData.allPenaltiesFromThisGame)
				setWinner(responseData.winner)
				setLoser(responseData.loser)
				setHomeGoalsTotal(responseData.homeGoalsTotal)
				setVisitorGoalsTotal(responseData.visitorGoalsTotal)

				console.log('responseData: ' + JSON.stringify(responseData))

				//console.log('game: ' + JSON.stringify(responseData.game))
				//console.log('game STATS: ' + JSON.stringify(responseData.gameStats))

				setIsLoading(false)
			} catch (err) {
				console.log('error ' + err)
				setError(err)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [gameId])
	//
	//
	console.log('inside GameSummary.js')
	//console.log('loadedGameStats: ' + JSON.stringify(loadedGameStats))
	//console.log('allGoalsFromThisGame: ' + JSON.stringify(allGoalsFromThisGame))
	//
	//
	//Here, I want to go to the backend, using the gameId, and get the roster lists
	//of both the home team and the visiting team.   getGameRostersAndPointsPerPeriod in admin-controller.js
	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/admin/${gameId}/rostersAndPoints`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setHomeRoster(responseData.homeRoster)
				setHomeTeamName(responseData.homeTeamName)
				setVisitorRoster(responseData.visitorRoster)
				setVisitorTeamName(responseData.visitorTeamName)
				setRosterPlayerGameStats(responseData.rosterPlayerGameStats)
				setGameStats(responseData.gameStats)
				setVenue(responseData.venue)
				setLeagueName(responseData.leagueName)
				setIsLoading(false)
			} catch (err) {
				//console.log('Error: ' + err)
				setError(err)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [gameId])
	//
	//
	//************************************************************************** */
	//
	//    chatGPT stuff
	//
	//************************************************************************** */
	const findRosterPlayerById = (rosterPlayerId) => {
		if (!rosterPlayerId || !homeRoster || !visitorRoster) return null
		return (
			homeRoster.find((p) => p._id === rosterPlayerId) ||
			visitorRoster.find((p) => p._id === rosterPlayerId) ||
			null
		)
	}

	const getPlayerIdFromRosterPlayerId = (rosterPlayerId) => {
		const rp = findRosterPlayerById(rosterPlayerId)
		return rp?.playerId // <-- THIS is the Player._id you want for /:playerId/history
	}

	const renderPlayerHistoryLink = (rosterPlayerId, label) => {
		const playerId = getPlayerIdFromRosterPlayerId(rosterPlayerId)
		if (!playerId) return label || ''
		return (
			<Link to={`/${playerId}/history`} className='playerHistoryLink'>
				{label}
			</Link>
		)
	}

	const getGameWinningGoalIndex = () => {
		if (!allGoalsFromThisGame || allGoalsFromThisGame.length === 0) return -1
		if (!winner) return -1
		if (loadedGame?.status === 'Shootout') return -1 // no GWG in shootout

		// Determine how many goals the losing team scored
		let losingGoals = 0

		if (winner === loadedGame?.homeTeamName) {
			losingGoals = Number(visitorGoalsTotal || 0)
		} else if (winner === loadedGame?.visitorTeamName) {
			losingGoals = Number(homeGoalsTotal || 0)
		} else {
			return -1
		}

		// The GWG is the (losingGoals + 1)th goal scored by the winning team
		const winningGoalNumberNeeded = losingGoals + 1

		let winningTeamGoalCount = 0

		for (let i = 0; i < allGoalsFromThisGame.length; i++) {
			const goal = allGoalsFromThisGame[i]

			if (goal.teamName === winner) {
				winningTeamGoalCount++

				if (winningTeamGoalCount === winningGoalNumberNeeded) {
					return i
				}
			}
		}

		return -1
	}

	const gameWinningGoalIndex = getGameWinningGoalIndex()

	//************************************************************************* */
	//
	//   end of chatGPT stuff
	//
	//************************************************************************** */
	//
	const getNumber = (playerId) => {
		let playerNumber
		homeRoster.forEach((homePlayer) => {
			if (homePlayer._id === playerId) {
				playerNumber = homePlayer.number
			}
		})
		visitorRoster.forEach((visitorPlayer) => {
			if (visitorPlayer._id === playerId) {
				playerNumber = visitorPlayer.number
			}
		})
		return playerNumber
	}
	//
	//
	//
	//
	const getPlayerName = (playerId) => {
		let playerFirstName, playerLastName
		homeRoster.forEach((homePlayer) => {
			if (homePlayer._id === playerId) {
				playerFirstName = homePlayer.firstName
				playerLastName = homePlayer.lastName
			}
		})
		visitorRoster.forEach((visitorPlayer) => {
			if (visitorPlayer._id === playerId) {
				playerFirstName = visitorPlayer.firstName
				playerLastName = visitorPlayer.lastName
			}
		})
		return playerFirstName + ' ' + playerLastName
	}
	//
	//
	//
	//
	const getTeamName = (playerId) => {
		let teamName
		homeRoster.forEach((homePlayer) => {
			if (homePlayer._id === playerId) {
				teamName = homePlayer.teamName
			}
		})
		visitorRoster.forEach((visitorPlayer) => {
			if (visitorPlayer._id === playerId) {
				teamName = visitorPlayer.teamName
			}
		})
		return teamName
	}
	//
	//
	const formatGameSummaryDate = (date) => {
		if (!date) return ''

		const [month, day] = date.split('-')

		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		return `${months[month]} ${parseInt(day)}`
	}

	const formatGameSummaryTime = (time) => {
		if (!time) return ''

		let [hours, minutes] = time.split(':')
		hours = parseInt(hours)

		const suffix = hours >= 12 ? 'pm' : 'am'

		hours = hours % 12

		if (hours === 0) {
			hours = 12
		}

		return `${hours}:${minutes} ${suffix}`
	}
	//
	//
	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				{!isLoading && loadedGame && (
					<div className='Summary'>
						{/* <h3 className='h3Center'>Coming soon.......</h3> */}
						<div className='gameSummaryMobileHero'>
							{(loadedGame.divisionName ||
								loadedGame.division ||
								leagueName) && (
								<div className='gameSummaryMobileDivision'>
									{loadedGame.divisionName || loadedGame.division || leagueName}
								</div>
							)}

							<div className='gameSummaryMobileScoreboard'>
								<div className='gameSummaryMobileTeam gameSummaryMobileVisitor'>
									<div className='gameSummaryMobileTeamName'>
										{loadedGame.visitorTeamName}
									</div>

									<div className='gameSummaryMobileScore'>
										{visitorGoalsTotal}
									</div>
								</div>

								<div className='gameSummaryMobileGameInfo'>
									<div className='gameSummaryMobileFinal'>
										{loadedGame.status === 'Overtime'
											? 'FINAL / OT'
											: loadedGame.status === 'Shootout'
												? 'FINAL / SO'
												: 'FINAL'}
									</div>

									<div className='gameSummaryMobileDate'>
										{loadedGame.dayOfWeek},{' '}
										{formatGameSummaryDate(loadedGame.date)}
									</div>

									<div className='gameSummaryMobileTime'>
										{formatGameSummaryTime(loadedGame.time)}
									</div>
								</div>

								<div className='gameSummaryMobileTeam gameSummaryMobileHome'>
									<div className='gameSummaryMobileScore'>{homeGoalsTotal}</div>

									<div className='gameSummaryMobileTeamName'>
										{loadedGame.homeTeamName}
									</div>
								</div>
							</div>

							{loadedGame.description && (
								<div className='gameSummaryMobileDescription'>
									{loadedGame.description}
								</div>
							)}

							{winner && (
								<div className='gameSummaryMobileWinner'>
									<span>Winner</span>
									<strong>{winner}</strong>
								</div>
							)}
						</div>

						<div className='gameSummaryHeroCard gameSummaryDesktopHero'>
							<h2>
								{loadedGame.visitorTeamName} @ {loadedGame.homeTeamName}
							</h2>

							<h4 className='gameSummaryDateTime'>
								{loadedGame.dayOfWeek},{' '}
								{loadedGame.date.substr(0, 2) === '01' &&
									'Jan. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '02' &&
									'Feb. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '03' &&
									'Mar. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '04' &&
									'Apr. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '05' &&
									'May ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '06' &&
									'June ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '07' &&
									'July ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '08' &&
									'Aug. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '09' &&
									'Sept. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '10' &&
									'Oct. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '11' &&
									'Nov. ' + loadedGame.date.substr(3, 2)}
								{loadedGame.date.substr(0, 2) === '12' &&
									'Dec. ' + loadedGame.date.substr(3, 2)}
								{' at '}
								{loadedGame.time.substr(0, 2) === '00' &&
									'12:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '01' &&
									'1:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '02' &&
									'2:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '03' &&
									'3:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '04' &&
									'4:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '05' &&
									'5:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '06' &&
									'6:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '07' &&
									'7:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '08' &&
									'8:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '09' &&
									'9:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '10' &&
									'10:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '11' &&
									'11:' + loadedGame.time.substr(3, 2) + ' am'}
								{loadedGame.time.substr(0, 2) === '12' &&
									'12:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '13' &&
									'1:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '14' &&
									'2:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '15' &&
									'3:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '16' &&
									'4:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '17' &&
									'5:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '18' &&
									'6:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '19' &&
									'7:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '20' &&
									'8:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '21' &&
									'9:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '22' &&
									'10:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '23' &&
									'11:' + loadedGame.time.substr(3, 2) + ' pm'}
								{loadedGame.time.substr(0, 2) === '24' &&
									'12:' + loadedGame.time.substr(3, 2) + ' am'}
							</h4>

							{loadedGame.description && (
								<div className='gameSummaryDescription'>
									{loadedGame.description}
								</div>
							)}

							<div className='gameSummaryDivider'></div>

							<div className='gameSummaryScorePill'>
								<div>Final Score</div>
								<strong>
									{loadedGame.score}

									{loadedGame.scoreSuffix && (
										<span className='gameSummaryScoreSuffix'>
											{' '}
											{loadedGame.scoreSuffix}
										</span>
									)}
								</strong>
							</div>

							<div className='gameSummaryDivider'></div>

							{winner && (
								<div className='gameSummaryWinner'>
									<span>Winner:</span>

									<strong>
										{winner}

										{loadedGame.status === 'Overtime' && ' won in OVERTIME'}

										{loadedGame.status === 'Shootout' && ' won in a SHOOTOUT'}
									</strong>
								</div>
							)}
						</div>
						{loadedGameStats.summary && (
							<div className='h3Center'>
								<textarea readOnly className='summaryBox'>
									{loadedGameStats && loadedGameStats.summary}
								</textarea>
							</div>
						)}
						<div>
							{!isLoading && homeRoster && visitorRoster && (
								<div>
									<div className='ScoringSummary'>
										<h3 className='gameSummarySectionTitle'>
											<span>Scoring Summary</span>
										</h3>
										<table
											id='scoringSummary'
											className='gameSummaryDesktopTable'
										>
											<thead>
												<tr>
													<th>Pd.</th>
													<th>Time</th>
													<th>Team</th>
													<th>G</th>
													<th>A</th>
													<th>A</th>
												</tr>
											</thead>
											<tbody>
												{allGoalsFromThisGame.map((goal, key) => {
													return (
														<tr key={key}>
															<td>{goal.period}</td>
															<td>{goal.time}</td>
															<td>{goal.teamName}</td>
															<td>
																{renderPlayerHistoryLink(
																	goal.scorer,
																	goal.scorerNumberAndName,
																)}
																{key === gameWinningGoalIndex && (
																	<span
																		style={{ fontWeight: 'bold', color: 'red' }}
																	>
																		{' '}
																		(GWG)
																	</span>
																)}
															</td>
															<td>
																{goal.assist1
																	? renderPlayerHistoryLink(
																			goal.assist1,
																			goal.a1NumberAndName,
																		)
																	: ''}
															</td>
															<td>
																{goal.assist2
																	? renderPlayerHistoryLink(
																			goal.assist2,
																			goal.a2NumberAndName,
																		)
																	: ''}
															</td>
														</tr>
													)
												})}
											</tbody>
										</table>
										<div className='gameSummaryMobileTable'>
											<div className='gameSummaryMobileTableHeader'>
												<div>Game</div>
												<div>Play</div>
											</div>

											{allGoalsFromThisGame.map((goal, key) => {
												return (
													<div className='gameSummaryMobilePlayRow' key={key}>
														<div className='gameSummaryMobileInfoCell'>
															<div className='gameSummaryMobilePeriodBadge'>
																{goal.period}
															</div>

															<div className='gameSummaryMobileMetaTime'>
																{goal.time}
															</div>

															<div className='gameSummaryMobileMetaTeam'>
																{goal.teamName}
															</div>
														</div>

														<div className='gameSummaryMobilePlayDetails'>
															<div className='gameSummaryMobileScorer'>
																{renderPlayerHistoryLink(
																	goal.scorer,
																	goal.scorerNumberAndName,
																)}

																{key === gameWinningGoalIndex && (
																	<span className='gameSummaryMobileGWG'>
																		GWG
																	</span>
																)}
															</div>

															{(goal.assist1 || goal.assist2) && (
																<div className='gameSummaryMobileAssists'>
																	<span>Asst: </span>

																	{goal.assist1 &&
																		renderPlayerHistoryLink(
																			goal.assist1,
																			goal.a1NumberAndName,
																		)}

																	{goal.assist1 && goal.assist2 && (
																		<span className='gameSummaryAssistSeparator'>
																			{' '}
																			|{' '}
																		</span>
																	)}

																	{goal.assist2 &&
																		renderPlayerHistoryLink(
																			goal.assist2,
																			goal.a2NumberAndName,
																		)}
																</div>
															)}

															{!goal.assist1 && !goal.assist2 && (
																<div className='gameSummaryMobileUnassisted'>
																	Unassisted
																</div>
															)}
														</div>
													</div>
												)
											})}
										</div>
									</div>
									<div className='ScoringSummary'>
										<h3 className='gameSummarySectionTitle'>
											<span>Penalties</span>
										</h3>
										<table
											id='scoringSummary'
											className='gameSummaryDesktopTable'
										>
											<thead>
												<tr>
													<th>Pd.</th>
													<th>Time</th>
													<th>Team</th>
													<th>Player</th>
													<th>Type</th>
													<th>Min.</th>
												</tr>
											</thead>
											<tbody>
												{allPenaltiesFromThisGame.map((penalty, key) => {
													return (
														<tr key={key}>
															<td>{penalty.period}</td>
															<td>{penalty.time}</td>
															<td>{penalty.teamName}</td>
															<td>
																{penalty.rosterPlayerId
																	? renderPlayerHistoryLink(
																			penalty.rosterPlayerId,
																			`${penalty.firstName || ''} ${penalty.lastName || ''}`.trim(),
																		)
																	: `${penalty.firstName || ''} ${penalty.lastName || ''}`.trim()}
															</td>
															<td>{penalty.penaltyType}</td>
															<td>{penalty.minutes}</td>
														</tr>
													)
												})}
											</tbody>
										</table>
										<div className='gameSummaryMobileTable'>
											<div className='gameSummaryMobileTableHeader'>
												<div>Game</div>
												<div>Penalty</div>
											</div>

											{allPenaltiesFromThisGame.map((penalty, key) => {
												const penaltyPlayerName =
													`${penalty.firstName || ''} ${penalty.lastName || ''}`.trim()

												return (
													<div className='gameSummaryMobilePlayRow' key={key}>
														<div className='gameSummaryMobileInfoCell'>
															<div className='gameSummaryMobilePeriodBadge'>
																{penalty.period}
															</div>

															<div className='gameSummaryMobileMetaTime'>
																{penalty.time}
															</div>

															<div className='gameSummaryMobileMetaTeam'>
																{penalty.teamName}
															</div>
														</div>

														<div className='gameSummaryMobilePlayDetails'>
															<div className='gameSummaryMobileScorer'>
																{penalty.rosterPlayerId
																	? renderPlayerHistoryLink(
																			penalty.rosterPlayerId,
																			penaltyPlayerName,
																		)
																	: penaltyPlayerName}
															</div>

															<div className='gameSummaryMobilePenaltyInfo'>
																{penalty.penaltyType}

																{penalty.minutes && (
																	<strong> • {penalty.minutes} min.</strong>
																)}
															</div>
														</div>
													</div>
												)
											})}

											{allPenaltiesFromThisGame.length === 0 && (
												<div className='gameSummaryMobileEmpty'>
													No penalties recorded.
												</div>
											)}
										</div>
									</div>
								</div>
							)}
						</div>
					</div>
				)}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default GameSummary
